<template>
  <div class="w-full">
    <div class="text-md" qaid="current-selection-type">{{ currentSelectionTypeText }}</div>
    <div v-if="!isActive" class="flex justify-between">
      <div v-if="!isCustomizationSize" class="text-xs text-gray-60" qaid="current-selection-name">
        {{ componentName }}
      </div>
      <div v-if="price" :class="[{'-mr-3': !isCustomComponentSelection}, 'text-xs']" qaid="current-selection-price">
        {{ price }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    componentType: {
      type: String,
      default: '',
    },
    componentName: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isCustomComponentSelection: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('productDetails', ['isCustomizationMode']),

    isCustomizationSize() {
      return this.isCustomizationMode && this.id.includes('sizeFrame');
    },
    currentSelectionTypeText() {
      return this.componentType.toLowerCase() === this.$t('text.model').toLowerCase()
        ? this.$t('product.family.detail.chooseModel')
        : this.componentType;
    },
  },
};
</script>
